import * as errorTypes from 'config/errorTypes';

export const CREATE_ACCOUNT_ERROR = {
    // 邀請過期
    [errorTypes.CREATE_ACCOUNT_INVITE_EXPIRED_ERROR]: r =>
        r.httpStatus === 400 &&
        r?.payload?.code === 'ADMSR-AU0-F0' &&
        r?.payload?.message === 'expired',
    [errorTypes.CREATE_ACCOUNT_INVITE_EXPIRED_ERROR]: r => r.httpStatus >= 400
};
